<template>
  <component
    :is="componentType"
    class="widget-dropdown-item"
    :href="href"
    :to="to"
  >
    <slot />
  </component>
</template>

<script lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import type { PropType } from '@/composition/vue/compositionApi'
import { computed, defineComponent } from '@/composition/vue/compositionApi'

export default defineComponent({
  props: {
    cursorDefault: {
      type: Boolean,
    },
    to: {
      type: Object as PropType<RouteLocationRaw>,
    },
    href: {
      type: String,
    },
  },
  setup(props) {
    const componentType = computed(() => {
      if (props.href) return 'a'
      if (props.to) return 'router-link'
      return 'button'
    })

    return {
      componentType,
    }
  },
})
</script>

<style lang="scss" scoped>
.widget-dropdown-item {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 100px;
  min-height: 36px;
  padding: 0 16px;
  border: 0;
  background: unset;
  font-family: $body-font-family;
  font-size: $font-size-root;
  font-weight: $semi-bold-font;
  line-height: 20px;
  text-align: left;
  white-space: nowrap;
  color: $emphasize;
  cursor: pointer;
  appearance: none;

  &:hover {
    background-color: $gray1;
  }
}
</style>
